import { render } from "./DatasourceDetail.vue?vue&type=template&id=e1e85152&scoped=true&ts=true"
import script from "./DatasourceDetail.vue?vue&type=script&lang=ts"
export * from "./DatasourceDetail.vue?vue&type=script&lang=ts"

import "./DatasourceDetail.vue?vue&type=style&index=0&id=e1e85152&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1e85152"]])

export default __exports__